// extracted by mini-css-extract-plugin
export default {"login":"Login_login__ZgdS8","col":"Login_col__P48xW","logo":"Login_logo__iydEn","head":"Login_head__SS6xM","link":"Login_link__0Ir6I","wrap":"Login_wrap__Ehndz"};